import { render } from "./WorkStationHeroSplit.vue?vue&type=template&id=045b7662&scoped=true"
import script from "./WorkStationHeroSplit.vue?vue&type=script&lang=js"
export * from "./WorkStationHeroSplit.vue?vue&type=script&lang=js"

import "./WorkStationHeroSplit.vue?vue&type=style&index=0&id=045b7662&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045b7662"]])

export default __exports__